import React, { useRef, useState } from 'react';
import TurnstileWidget from './TurnstileWidget';
import { config } from '../config/environment';
import { submitCoffeeShopInterest, submitCompanyInterest } from '../services/interestSubmissionService';
import { track } from '../services/analytics';
export default function PartnerForm({
  company = false
}) {
  const [data, setData] = useState({});
  const [token, setToken] = useState(null);
  const [status, setStatus] = useState('loading');
  const [sending, setSending] = useState(false);
  const [invalidField, setInvalidField] = useState(null);
  const started = useRef(false),
    lock = useRef(false),
    widget = useRef(null);
  const fields = [['nome', 'Seu nome', 'text'], [company ? 'nomeEmpresa' : 'nomeCafeteria', company ? 'Nome da empresa' : 'Nome da cafeteria', 'text'], ['email', 'E-mail', 'email'], ['telefone', 'Telefone', 'tel'], ['cidade', 'Cidade', 'text'], ...(company ? [['cargo', 'Cargo', 'text']] : [['endereco', 'Endereço', 'text']])];
  const captchaFailed = useRef(false);
  const captchaError = () => {
    if (!captchaFailed.current) track('partner_form_captcha_error');
    captchaFailed.current = true;
    setToken(null);
    setStatus('captcha');
  };
  async function submit(e) {
    e.preventDefault();
    if (!token || lock.current) return;
    const invalid = fields.find(([name]) => !data[name]?.trim());
    setInvalidField(invalid || null);
    if (invalid) {
      e.currentTarget.elements.namedItem(invalid[0])?.focus();
      return;
    }
    lock.current = true;
    setSending(true);
    setStatus('sending');
    track('partner_form_submit');
    try {
      await (company ? submitCompanyInterest : submitCoffeeShopInterest)(data, token);
      setData({});
      setStatus('success');
      track('partner_form_success');
    } catch (error) {
      setStatus('error');
      track('partner_form_error', {
        category: error.category === 'server' ? 'server' : 'network'
      });
    } finally {
      setToken(null);
      widget.current?.reset();
      setSending(false);
      lock.current = false;
    }
  }
  const messages = {
    loading: 'Carregando verificação de segurança…',
    ready: 'Verificação concluída. Você pode enviar.',
    captcha: 'A verificação falhou ou expirou. Tente novamente.',
    sending: 'Enviando…',
    success: 'Interesse registrado! Entraremos em contato em breve.',
    error: 'Não foi possível enviar. Faça uma nova verificação e tente novamente.'
  };
  return <section id="formulario" className="container form-section"><h2>{company ? 'Solicite uma conversa' : 'Quero ser parceiro'}</h2><p>Conte-nos sobre seu negócio. Nossa equipe entrará em contato.</p>
    <form onSubmit={submit} aria-busy={sending} onFocus={() => {
      if (!started.current) {
        started.current = true;
        track('partner_form_start');
      }
    }}>
      <div className="field-grid">{fields.map(([name, label, type]) => <label key={name} htmlFor={name}>{label}<input id={name} name={name} type={type} required aria-invalid={invalidField?.[0] === name ? true : undefined} aria-describedby={invalidField?.[0] === name ? 'partner-field-error' : undefined} maxLength={150} value={data[name] || ''} onChange={e => setData({
            ...data,
            [name]: e.target.value
          })} /></label>)}</div>
      <label htmlFor="mensagem">Mensagem (opcional)<textarea id="mensagem" name="mensagem" maxLength={1000} rows={4} value={data.mensagem || ''} onChange={e => setData({
          ...data,
          mensagem: e.target.value
        })} /></label>
      <TurnstileWidget ref={widget} siteKey={config.turnstile.siteKey} size="flexible" onVerify={value => {
        captchaFailed.current = false;
        setToken(value);
        setStatus(s => s === 'success' ? s : 'ready');
      }} onError={captchaError} onExpire={() => {
        setToken(null);
        setStatus(s => ['success', 'error'].includes(s) ? s : 'captcha');
      }} />
      {invalidField && <p id="partner-field-error" role="alert">Preencha o campo {invalidField[1]} com um valor válido, não apenas espaços.</p>}
      <p role="status" aria-live="polite">{messages[status]}</p>
      {status === 'captcha' && <button type="button" onClick={() => {
        setStatus('loading');
        widget.current?.reset();
      }}>Tentar verificação novamente</button>}
      <button type="submit" disabled={!token || sending}>{sending ? 'Enviando…' : 'Enviar interesse'}</button>
      <p>Se preferir ou encontrar dificuldades, escreva para <a href="mailto:contato@coffeein.club">contato@coffeein.club</a>.</p>
    </form></section>;
}
